import _ from "lodash";
import React from "react";
import { connect } from "react-redux";

import { Button } from "react-bootstrap";

import bindActions from "../../../../helpers/bindActions";
import * as chartSideTransactionActions from "../../../../actions/chartSideTransactionActions";
import { Modal } from "../../../ui/Modal";
import { openSimpleModal } from "../../../../actions/simpleModalActions";
import Show from "../../../widgets/Show";

const enhancer = connect(
  ({
    chartSideTransaction,
    session: {
      permissions,
      miscSettings: { mandatoryCompletedTransactionVoidingReason },
    },
  }) => ({
    permissions,
    mandatoryCompletedTransactionVoidingReason,
    chooseDeleteModalVisible: chartSideTransaction.chooseDeleteModalVisible,
    transactionItem: _.get(chartSideTransaction, "transactionItem.status.code"),
  }),
  bindActions({ chartSideTransactionActions, openSimpleModal }),
);
export default enhancer(
  class ChartTransactionChooseDeleteModal extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        voidReason: "",
      };
    }

    handleVoid = () => {
      let accessDelete = false;

      if (this.props.permissions && this.props.permissions.length) {
        if (this.props.transactionItem === "DentalTransactionStatus_PLANNED") {
          if (this.props.permissions.indexOf("VOID_PLANNED_DENTAL_TRANSACTION_ITEM") > 0) {
            accessDelete = true;
          }
        }
        if (this.props.transactionItem === "DentalTransactionStatus_COMPLETED") {
          if (this.props.permissions.indexOf("VOID_COMPLETED_DENTAL_TRANSACTION_ITEM") > 0) {
            accessDelete = true;
          }
        }
      }

      if (accessDelete) {
        this.props.chartSideTransactionActions.voidItem(this.state.voidReason);
        this.props.chartSideTransactionActions.closeChooseDeleteModal();
        this.setState({ voidReason: "" });
      } else {
        this.props.chartSideTransactionActions.closeChooseDeleteModal();
        this.props.chartSideTransactionActions.openAccessDeleteModal();
        this.setState({ voidReason: "" });
      }
    };

    handleDelete = () => {
      let accessDelete = false;
      if (this.props.permissions && this.props.permissions.length) {
        if (this.props.transactionItem === "DentalTransactionStatus_PLANNED") {
          if (this.props.permissions.indexOf("REMOVE_PLANNED_DENTAL_TRANSACTION_ITEM") !== -1) {
            accessDelete = true;
          }
        }
        if (this.props.transactionItem === "DentalTransactionStatus_COMPLETED") {
          if (this.props.permissions.indexOf("REMOVE_COMPLETED_DENTAL_TRANSACTION_ITEM") !== -1) {
            accessDelete = true;
          }
        }
      }
      if (!accessDelete) {
        this.props.openSimpleModal({
          body: "Permission denied",
        });
      }
      if (accessDelete) {
        this.props.chartSideTransactionActions.deleteItem();
        this.props.chartSideTransactionActions.closeChooseDeleteModal();
      } else {
        this.props.chartSideTransactionActions.closeChooseDeleteModal();
        this.props.chartSideTransactionActions.openAccessDeleteModal();
      }
    };
    render() {
      const { mandatoryCompletedTransactionVoidingReason, transactionItem } = this.props;
      const requiresVoidReason =
        mandatoryCompletedTransactionVoidingReason &&
        transactionItem === "DentalTransactionStatus_COMPLETED";

      return (
        <Modal
          size="sm"
          animation={false}
          show={this.props.chooseDeleteModalVisible}
          onHide={() => {
            this.props.chartSideTransactionActions.closeChooseDeleteModal();
            this.setState({ voidReason: "" });
          }}
          keyboard={false}
          className="d-flex"
          dialogClassName="d-flex align-items-center"
          title="Choose action:"
        >
          <div
            className={`d-flex flex-column ${
              requiresVoidReason ? "voiding-reason-wrapper" : "simple-dialog"
            }`}
          >
            <Show if={requiresVoidReason}>
              <div className="voiding-reason-dialog">
                <label className="reason-label" htmlFor="voidReason">
                  Reason for voiding<span className="required">*</span>
                </label>
                <div className="form-textarea d-flex flex-column">
                  <textarea
                    rows="5"
                    id="voidReason"
                    className="form-textarea"
                    placeholder="Please provide a detailed explanation for why this action needs to be voided..."
                    maxLength="500"
                    required={true}
                    value={_.unescape(this.state.voidReason)}
                    onChange={(e) => this.setState({ voidReason: _.escape(e.target.value) })}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
                        e.preventDefault();
                        this.handleVoid();
                      }
                    }}
                  ></textarea>
                  <span className="char-count mt-1 text-right">
                    {this.state.voidReason.length}/500
                  </span>
                </div>
              </div>
            </Show>
            <div className="d-flex align-items-center justify-content-between">
              <Button
                bsStyle="danger"
                disabled={!this.state.voidReason.length && requiresVoidReason}
                className="mr-2 flex flex-shrink-0 flex-grow-1"
                onClick={this.handleVoid}
              >
                Void
              </Button>
              <Button
                onClick={() => {
                  this.props.chartSideTransactionActions.closeChooseDeleteModal();
                  this.setState({ voidReason: "" });
                }}
                className="flex flex-shrink-0 flex-grow-1"
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      );
    }
  },
);
